export const EXTERNAL_API_LOAD_EXTERNAL_APIS_BEGIN = 'EXTERNAL_API_LOAD_EXTERNAL_APIS_BEGIN';
export const EXTERNAL_API_LOAD_EXTERNAL_APIS_SUCCESS = 'EXTERNAL_API_LOAD_EXTERNAL_APIS_SUCCESS';
export const EXTERNAL_API_LOAD_EXTERNAL_APIS_FAILURE = 'EXTERNAL_API_LOAD_EXTERNAL_APIS_FAILURE';
export const EXTERNAL_API_LOAD_EXTERNAL_APIS_DISMISS_ERROR =
  'EXTERNAL_API_LOAD_EXTERNAL_APIS_DISMISS_ERROR';
export const EXTERNAL_API_DELETE_EXTERNAL_API_BEGIN = 'EXTERNAL_API_DELETE_EXTERNAL_API_BEGIN';
export const EXTERNAL_API_DELETE_EXTERNAL_API_SUCCESS = 'EXTERNAL_API_DELETE_EXTERNAL_API_SUCCESS';
export const EXTERNAL_API_DELETE_EXTERNAL_API_FAILURE = 'EXTERNAL_API_DELETE_EXTERNAL_API_FAILURE';
export const EXTERNAL_API_DELETE_EXTERNAL_API_DISMISS_ERROR =
  'EXTERNAL_API_DELETE_EXTERNAL_API_DISMISS_ERROR';
export const EXTERNAL_API_CREATE_EXTERNAL_API_BEGIN = 'EXTERNAL_API_CREATE_EXTERNAL_API_BEGIN';
export const EXTERNAL_API_CREATE_EXTERNAL_API_SUCCESS = 'EXTERNAL_API_CREATE_EXTERNAL_API_SUCCESS';
export const EXTERNAL_API_CREATE_EXTERNAL_API_FAILURE = 'EXTERNAL_API_CREATE_EXTERNAL_API_FAILURE';
export const EXTERNAL_API_CREATE_EXTERNAL_API_DISMISS_ERROR =
  'EXTERNAL_API_CREATE_EXTERNAL_API_DISMISS_ERROR';
export const EXTERNAL_API_UPDATE_EXTERNAL_API_BEGIN = 'EXTERNAL_API_UPDATE_EXTERNAL_API_BEGIN';
export const EXTERNAL_API_UPDATE_EXTERNAL_API_SUCCESS = 'EXTERNAL_API_UPDATE_EXTERNAL_API_SUCCESS';
export const EXTERNAL_API_UPDATE_EXTERNAL_API_FAILURE = 'EXTERNAL_API_UPDATE_EXTERNAL_API_FAILURE';
export const EXTERNAL_API_UPDATE_EXTERNAL_API_DISMISS_ERROR =
  'EXTERNAL_API_UPDATE_EXTERNAL_API_DISMISS_ERROR';
export const EXTERNAL_API_LOAD_EXTERNAL_API_BEGIN = 'EXTERNAL_API_LOAD_EXTERNAL_API_BEGIN';
export const EXTERNAL_API_LOAD_EXTERNAL_API_SUCCESS = 'EXTERNAL_API_LOAD_EXTERNAL_API_SUCCESS';
export const EXTERNAL_API_LOAD_EXTERNAL_API_FAILURE = 'EXTERNAL_API_LOAD_EXTERNAL_API_FAILURE';
export const EXTERNAL_API_LOAD_EXTERNAL_API_DISMISS_ERROR =
  'EXTERNAL_API_LOAD_EXTERNAL_API_DISMISS_ERROR';
export const EXTERNAL_API_LOAD_COLLECTIONS_BEGIN = 'EXTERNAL_API_LOAD_COLLECTIONS_BEGIN';
export const EXTERNAL_API_LOAD_COLLECTIONS_SUCCESS = 'EXTERNAL_API_LOAD_COLLECTIONS_SUCCESS';
export const EXTERNAL_API_LOAD_COLLECTIONS_FAILURE = 'EXTERNAL_API_LOAD_COLLECTIONS_FAILURE';
export const EXTERNAL_API_LOAD_COLLECTIONS_DISMISS_ERROR =
  'EXTERNAL_API_LOAD_COLLECTIONS_DISMISS_ERROR';
export const EXTERNAL_API_LOAD_IN_MEMORY_COLLECTION_BEGIN =
  'EXTERNAL_API_LOAD_IN_MEMORY_COLLECTION_BEGIN';
export const EXTERNAL_API_LOAD_IN_MEMORY_COLLECTION_SUCCESS =
  'EXTERNAL_API_LOAD_IN_MEMORY_COLLECTION_SUCCESS';
export const EXTERNAL_API_LOAD_IN_MEMORY_COLLECTION_FAILURE =
  'EXTERNAL_API_LOAD_IN_MEMORY_COLLECTION_FAILURE';
export const EXTERNAL_API_LOAD_IN_MEMORY_COLLECTION_DISMISS_ERROR =
  'EXTERNAL_API_LOAD_IN_MEMORY_COLLECTION_DISMISS_ERROR';
export const EXTERNAL_API_SEND_MOCK_DATA_REQUEST_BEGIN =
  'EXTERNAL_API_SEND_MOCK_DATA_REQUEST_BEGIN';
export const EXTERNAL_API_SEND_MOCK_DATA_REQUEST_SUCCESS =
  'EXTERNAL_API_SEND_MOCK_DATA_REQUEST_SUCCESS';
export const EXTERNAL_API_SEND_MOCK_DATA_REQUEST_FAILURE =
  'EXTERNAL_API_SEND_MOCK_DATA_REQUEST_FAILURE';
export const EXTERNAL_API_SEND_MOCK_DATA_REQUEST_DISMISS_ERROR =
  'EXTERNAL_API_SEND_MOCK_DATA_REQUEST_DISMISS_ERROR';
export const EXTERNAL_API_SHOW_COLLECTION_MAPPING = 'EXTERNAL_API_SHOW_COLLECTION_MAPPING';
export const EXTERNAL_API_CLONE_EXTERNAL_API_BEGIN = 'EXTERNAL_API_CLONE_EXTERNAL_API_BEGIN';
export const EXTERNAL_API_CLONE_EXTERNAL_API_SUCCESS = 'EXTERNAL_API_CLONE_EXTERNAL_API_SUCCESS';
export const EXTERNAL_API_CLONE_EXTERNAL_API_FAILURE = 'EXTERNAL_API_CLONE_EXTERNAL_API_FAILURE';
export const EXTERNAL_API_CLONE_EXTERNAL_API_DISMISS_ERROR =
  'EXTERNAL_API_CLONE_EXTERNAL_API_DISMISS_ERROR';
export const EXTERNAL_API_LOAD_EXTERNAL_DATABASE_BEGIN =
  'EXTERNAL_API_LOAD_EXTERNAL_DATABASE_BEGIN';
export const EXTERNAL_API_LOAD_EXTERNAL_DATABASE_SUCCESS =
  'EXTERNAL_API_LOAD_EXTERNAL_DATABASE_SUCCESS';
export const EXTERNAL_API_LOAD_EXTERNAL_DATABASE_FAILURE =
  'EXTERNAL_API_LOAD_EXTERNAL_DATABASE_FAILURE';
export const EXTERNAL_API_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR =
  'EXTERNAL_API_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR';
export const EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_BEGIN =
  'EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_BEGIN';
export const EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_SUCCESS =
  'EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_SUCCESS';
export const EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_FAILURE =
  'EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_FAILURE';
export const EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_DISMISS_ERROR =
  'EXTERNAL_API_UPDATE_EXTERNAL_API_TYPE_DISMISS_ERROR';
export const EXTERNAL_API_GET_PERMISSION_FLAGS_BEGIN = 'EXTERNAL_API_GET_PERMISSION_FLAGS_BEGIN';
export const EXTERNAL_API_GET_PERMISSION_FLAGS_SUCCESS =
  'EXTERNAL_API_GET_PERMISSION_FLAGS_SUCCESS';
export const EXTERNAL_API_GET_PERMISSION_FLAGS_FAILURE =
  'EXTERNAL_API_GET_PERMISSION_FLAGS_FAILURE';
export const EXTERNAL_API_GET_PERMISSION_FLAGS_DISMISS_ERROR =
  'EXTERNAL_API_GET_PERMISSION_FLAGS_DISMISS_ERROR';
